/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {
  DashboardToDoList,
  ListsWidget2,
  ListsWidget4,
  ListsWidget5,
  ListsWidget6,
  MixedWidget10,
  MixedWidget11,
  MixedWidget2,
  MixedWidget8,
  TablesWidget10,
} from '../../../_metronic/partials/widgets'
import {useAuth} from '../../modules/auth'

const DashboardPage: FC = () => {
  return (
    <>
      {/* begin::Row */}
      <div className='row gy-5 gx-xl-8'>
        <div className='col-xxl-4'>
          <ListsWidget4 className='card-xl-stretch mb-5 mb-xl-8' items={5} />
        </div>
        <div className='col-xl-8'>
          <TablesWidget10 className='card-xxl-stretch mb-5 mb-xl-8' />
        </div>
      </div>
      {/* end::Row */}
      
      {/*/!* begin::Row *!/*/}
      {/*<div className='row gy-5 g-xl-8'>*/}
      {/*  <div className='col-xxl-4'>*/}
      {/*    <MixedWidget8*/}
      {/*      className='card-xxl-stretch mb-xl-3'*/}
      {/*      chartColor='success'*/}
      {/*      chartHeight='150px'*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*  <div className='col-xxl-4'>*/}
      {/*    <ListsWidget5 className='card-xxl-stretch' />*/}
      {/*  </div>*/}
      {/*  <div className='col-xxl-4'>*/}
      {/*    <MixedWidget10*/}
      {/*      className='card-xxl-stretch-50 mb-5 mb-xl-8'*/}
      {/*      chartColor='primary'*/}
      {/*      chartHeight='150px'*/}
      {/*    />*/}
      {/*    <MixedWidget11*/}
      {/*      className='card-xxl-stretch-50 mb-5 mb-xl-8'*/}
      {/*      chartColor='primary'*/}
      {/*      chartHeight='175px'*/}
      {/*    />*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/*/!* end::Row *!/*/}
      
      {/*/!* begin::Row *!/*/}
      {/*<div className='row gy-5 g-xl-8'>*/}
      {/*  <div className='col-xl-4'>*/}
      {/*    <ListsWidget2 className='card-xl-stretch mb-xl-8' />*/}
      {/*  </div>*/}
      {/*  <div className='col-xl-4'>*/}
      {/*    <ListsWidget6 className='card-xl-stretch mb-xl-8' />*/}
      {/*  </div>*/}
      {/*  <div className='col-xl-4'>*/}
      {/*    <MixedWidget2*/}
      {/*      className='card-xl-stretch mb-xl-8'*/}
      {/*      chartColor='danger'*/}
      {/*      chartHeight='200px'*/}
      {/*      strokeColor='#cb1e46'*/}
      {/*    />*/}
      {/*    /!* partials/widgets/lists/_widget-4', 'class' => 'card-xl-stretch mb-5 mb-xl-8', 'items' => '5' *!/*/}
      {/*  </div>*/}
      {/*</div>*/}
      {/*/!* end::Row *!/*/}
    </>
  )
}

const UserDashboardPage: FC = () => {
  const {isAdmin, userVerifyRoles} = useAuth()

  const showTodoList = userVerifyRoles(['Labor Editor', 'Benchmarking Editor']) || isAdmin
  return (
    <>
      {/* begin::Row */}
      <div className='row gy-5 gx-xl-8'>
        <div className='col-xxl-4'>
          {showTodoList && <DashboardToDoList className='card-xxl mb-xl-8 mb-5' />}
          <ListsWidget4 items={5} />
        </div>
        <div className='col-xxl-8'>
          <TablesWidget10 className='card-xxl-stretch mb-xl-3' />
        </div>
      </div>
      {/* end::Row */}
    </>
  )
}

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  const {isAdmin} = useAuth()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      {isAdmin ? <DashboardPage /> : <UserDashboardPage />}
    </>
  )
}

export {DashboardWrapper}
